<template>
  <div class="AdminActivityFilterBar">
    <div class="container-fluid">
      <div class="row margin-top-3Perc vertical-align">
        <div class="col-md-1 col-lg-1 text-align-right">Admin</div>
        <div class="col-md-3 col-lg-3 Padding-left-0px font-size-18px">    
          <select class="form-control" v-model="selectedUserObj">
            <option value=-1 disabled>Select</option>
            <option v-for="userObj in getAdminList" v-bind:key="userObj.UserId" v-bind:value="userObj">
              {{ userObj.FirstName + ' ' + userObj.LastName }}
            </option>
          </select>                  
        </div> 
        <div class="col-md-2 col-lg-1 text-align-right Padding-left-0px">
          Start date
        </div>
        <div class="col-md-2 col-lg-2 Padding-left-0px">
          <date-picker v-model="startDate" :config="config"></date-picker>
        </div>
        <div class="col-md-2 col-lg-1 text-align-right Padding-left-0px">
          End date
        </div>
        <div class="col-md-2 col-lg-2 Padding-left-0px">
          <date-picker v-model="endDate" :config="config"></date-picker>
        </div>
        <div class="col-md-2 col-lg-2 Padding-left-0px">
          <button type="button" class="btn btn-default col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8" @click="showActivity($event)">Go</button>
        </div>
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
  </div>
</template>

<script>
import datePicker from 'vue-bootstrap-datetimepicker'
import moment from 'moment'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { adminActivityService } from '@/server-util/admin-activity-service'
import Loader from '@/components/dashboard/Loader'
export default {
  created: function () {
    this.setDefaultValues()
    this.getAdminUsers()
  },
  data: function () {
    var startTS = moment().tz('America/New_York').format('MM/DD/YYYY')
    return {
      selectedUserObj: -1,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      startDate: startTS,
      config: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
        maxDate: ''
      },
      adminUsers: [],
      endDate: startTS
    }
  },
  components: {
    'alert-box': AlertBox,
    'date-picker': datePicker,
    'loader': Loader
  },
  methods: {
    setDefaultValues: function () {
      this.config.maxDate = new Date()
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAdminUsers: function () {
      // this.$store.state.isLoading = true
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        if (storeObj.state.adminUsers.length === 0) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
        } else {
          this.adminUsers = storeObj.state.adminUsers
        }
        adminActivityService.getAllAdminUsers(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.adminUsers = responseObj.data
              this.adminUsers = storeObj.state.adminUsers
              // this.showSpinner = false
              this.$store.state.isLoading = false
            } else {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    showActivity: function () {
      if (this.selectedUserObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an admin.'
        return
      }
      if (this.startDate === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a start date.'
        return
      }
      if (this.endDate === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an end date.'
        return
      }
      if (Date.parse(this.startDate) > Date.parse(this.endDate)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start date must be less than the end date.'
        return
      }
      var sendData = {
        User: this.selectedUserObj,
        StartDate: this.startDate,
        EndDate: this.endDate
      }
      this.$emit('onGetAdminActivity', sendData)
    }
  },
  computed: {
    getAdminList: {
      get: function () {
        return this.adminUsers
      }
    }
  },
  name: 'AdminActivityFilterBar'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.AdminActivityFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.margin-top-3Perc{
    margin-top:3%;
}
.labelText {
    /* display: inline-flex; */
    /* height: 34px; */
    /* align-items: center; */
    /* font-size: 14px; */
    /* font-weight: 600; */
}
.black-border{
    border-left: 1px solid #aaa;
}
.padding-left-2Perc{
    padding-left:2%;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.text-align-right{
  text-align: right !important;
}
.Padding-left-0px {
  padding-left: 0px !important;
}
.margin-left-2Perc{
  margin-left:2%;
}
.center-div{
  margin: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminActivityFilterBar.vue